import { SingleDataValue } from '.';
import { ThemedFlex } from '../../theme/ThemedFlex';

export const MiningTileDifficulty = ({ data, formatLargeNumber, animate }) => {
  const numberValue = data?.s03?.bitcoin_stats?.bitcoin_data?.difficulty != null
    ? `${formatLargeNumber(data.s03.bitcoin_stats.bitcoin_data.difficulty, 2, false) ?? "Loading..."}`
    : '';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="Difficulty" value={numberValue} />
    </ThemedFlex>
  );
};
